/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1FeedbackFeedbackidLangs200,
  GetApiV1FeedbackFeedbackidLangs401,
  GetApiV1FeedbackFeedbackidLangs404,
  GetApiV1FeedbackFeedbackidLangs500,
  GetApiV1FeedbackFeedbackidLangsPathParams,
  GetApiV1FeedbackFeedbackidLangsQueryParams,
  GetApiV1FeedbackFeedbackidLangsQueryResponse,
} from "../../types/feedbackIdiomasController/GetApiV1FeedbackFeedbackidLangs.ts";
import { feedbackLangViewModelPaginatedResponseSchema } from "../feedbackLangViewModelPaginatedResponseSchema.ts";

export const getApiV1FeedbackFeedbackidLangsPathParamsSchema = z.object({
  feedbackId: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsPathParams>;

export const getApiV1FeedbackFeedbackidLangsQueryParamsSchema = z.object({
  page: z.coerce.number().int().default(1),
  pageSize: z.coerce.number().int().default(20),
}) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1FeedbackFeedbackidLangs200Schema = z.lazy(
  () => feedbackLangViewModelPaginatedResponseSchema,
) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangs200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1FeedbackFeedbackidLangs401Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidLangs401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1FeedbackFeedbackidLangs404Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidLangs404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1FeedbackFeedbackidLangs500Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackFeedbackidLangs500>;

export const getApiV1FeedbackFeedbackidLangsQueryResponseSchema = z.lazy(
  () => getApiV1FeedbackFeedbackidLangs200Schema,
) as unknown as ToZod<GetApiV1FeedbackFeedbackidLangsQueryResponse>;
